import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountRemapListingIndexSelect implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountRemapListingIndexSelectContainer";
    }
    render(){
        // console.log("listing index remap select");
    }
}